import type { BenefitIconType } from "../types";

const iconPath = (file: string) => `/assets/benefits/${file}`;

const benefitIconMap: Record<BenefitIconType, string> = {
    shipping: iconPath("shipping.svg"),
    returns: iconPath("returns.svg"),
    earlyAccess: iconPath("earlyAccess.svg"),
    experiences: iconPath("experiences.svg"),
    anniversary: iconPath("anniversary.svg"),
    rewards: iconPath("rewards.svg"),
    newArrivals: iconPath("newArrivals.png"),
    birthday: iconPath("birthday.svg"),
    andMore: iconPath("andMore.svg"),
};

export const getBenefitIcon = (iconType: BenefitIconType): string => {
    return benefitIconMap[iconType];
};
